import {TextureType} from "@cm/material-nodes"

export type PconExportConfig = {
    commonWidthCm: number
    commonHeightCm: number
    format: "jpeg" | "png"
}

export const PCON_EXPORT_DEFAULT_TEXTURE_TYPES = [TextureType.Diffuse, TextureType.Normal, TextureType.Metalness, TextureType.Roughness] as const
export const PCON_EXPORT_OPACITY = "Opacity" as const
export type PconExportTextureType = (typeof PCON_EXPORT_DEFAULT_TEXTURE_TYPES)[number] | typeof PCON_EXPORT_OPACITY

export const PCON_EXPORT_EXTENSION = "matz" as const

export function getDefaultPconExportConfig(params: {commonWidthCm: number; commonHeightCm: number}): PconExportConfig {
    return {
        ...params,
        format: "jpeg",
    }
}
